module.exports = __webpack_public_path__ + "img/404.386f3fca.png";